import React from "react";
import { twMerge } from "tailwind-merge";
import { theme } from "./index";

interface AssetsProps {
  className?: string;
}

export const Assets: React.FC<AssetsProps> = ({ className }) => (
  <svg
    width="19"
    height="13"
    viewBox="0 0 19 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={twMerge(
      theme,
      className,
    )}
  >
    <path d="M15.0417 11.0125C15.869 11.0125 16.5383 10.3356 16.5383 9.50834L16.5458 1.9875C16.5458 1.16021 15.869 0.483337 15.0417 0.483337H3.00833C2.18104 0.483337 1.50417 1.16021 1.50417 1.9875V9.50834C1.50417 10.3356 2.18104 11.0125 3.00833 11.0125H0V12.5167H18.05V11.0125H15.0417ZM3.00833 1.9875H15.0417V9.50834H3.00833V1.9875Z" />
  </svg>
);
